import styled, { css } from 'styled-components';

import { Container, ImageContainer, ImageLink, Inner, Name } from '../Course.styled';

export const StyledContainer = styled(Container)`
    ${({ theme }) => css`
        @media ${theme.breakpoints.large.media} {
            flex-direction: column;
            height: 100%;
        }
    `}
`;

export const StyledImageContainer = styled(ImageContainer)`
    ${({ theme }) => css`
        place-items: start;
        padding: 0 0 0 1rem;

        &:before {
            height: 2.875rem;
        }

        @media ${theme.breakpoints.medium.media} {
            padding: 1rem 0;
            place-items: center;

            &:before {
                height: 100%;
            }
        }

        @media ${theme.breakpoints.large.media} {
            &:before {
                width: 100%;
                height: 20%;
                bottom: 0;
                left: 0;
                top: unset;
                right: unset;
                border-radius: 0.5rem 0.5rem 0 0;
            }

            place-items: start;
            padding-top: 0;
            padding-bottom: 0;
        }
    `}
`;

export const StyledImageLink = styled(ImageLink)`
    ${({ theme }) => css`
        width: 9rem;
        height: 5.75rem;

        @media ${theme.breakpoints.medium.media} {
            width: 9rem;
            height: 5.75rem;
        }

        @media ${theme.breakpoints.large.media} {
            width: 14.5rem;
            height: 9.25rem;
            margin-left: 0.75rem;
        }
    `}
`;

export const StyledInner = styled(Inner)`
    ${({ theme }) => css`
        padding: 1rem;

        @media ${theme.breakpoints.medium.media} {
            padding: 1rem;
        }

        @media ${theme.breakpoints.large.media} {
            padding: 1rem 0.75rem;
            border-radius: 0 0 0.5rem 0.5rem;
            height: 100%;
        }
    `}
`;

export const StyledName = styled(Name).attrs({
    as: 'h3'
})`
    ${({ theme }) => css`
        @media ${theme.breakpoints.large.media} {
            padding-right: 0;
        }
    `}
`;
